import { faBars, faChevronLeft } from '@fortawesome/pro-light-svg-icons'
import { useCallback, useMemo, useState } from 'react'
import { twinFetchPostText } from '../../../../utils/globals/data'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { filterTabsByPermissions, useTabObjectLogic } from '../../../../utils/hooks/useTabLogic'
import { UserPermissions } from '../../../CreateRoutering/types'
import { EditCardTabsLeftBarDiv } from '../../../EditCardTabs'
import { TabsInfo } from '../../../EditCardTabs/types'
import { ModalOpenedTy } from '../../../Modal/types'
import TwinIcon from '../../../TwinIcon'
import TwinTrans from '../../../TwinTrans'
import { SetCompleteDataTy } from '../types'
import { InputTableLeftColumnChange } from './types'

interface InputTableLeftColumnParentProps {}

type InputTableLeftColumnRequiredProps = {
    updateDataURL: string
    getCompleteData: () => void
    headerData?: TwinDictionary
}

type InputTableLeftColumnProps = InputTableLeftColumnParentProps & InputTableLeftColumnRequiredProps & InputTableLeftColumnLogicProps

const InputTableLeftColumn: React.FC<InputTableLeftColumnProps> = ({ headerData, userPermissions, tabs, ...rest }) => {
    const { handleChange, setOpenModal, openModal, tabsFiltered, active, ComponentFromTab, changeTab } = useInputTableLeftColumnLogic({...rest, tabs, userPermissions})
    if (!tabsFiltered || !Object.keys(tabsFiltered).length) {
        return null
    }
    const tabActive = tabs[active]
    return (
        <div className='flex flex-col input_table_left_column flex-auto '>
            <div className='regular18 flex items-center justify-between input_table_left_column_header'>
                <span>{tabActive.text}</span>
                {Object.keys(tabs).length > 1 ? <TwinIcon icon={faBars} className='cursor-pointer' onClick={() => setOpenModal(true)} /> : null}
            </div>
            <div className='flex flex-auto h-1 input_table_left_column_content'>
                <ComponentFromTab handleChange={handleChange} {...tabActive.extraProps} headerData={headerData} userPermissions={userPermissions} {...rest} />
            </div>
            <div className={'input_table_left_column_tabs ' + (openModal ?  'active' : '')}>
                <div className='input_table_left_close_modal_div' onClick={() => setOpenModal(null)}>
                    <TwinIcon icon={faChevronLeft} className='icon_close_modal' />
                    <span><TwinTrans transKey='return'>Volver</TwinTrans></span>
                </div>
                <EditCardTabsLeftBarDiv tabs={tabs} onClick={changeTab} tab={active} />
            </div>
        </div>
    )
}

interface InputTableLeftColumnLogicParentProps extends TabsInfo {
    updateDataURL: string
}

type InputTableLeftColumnLogicRequiredProps = {
    setCompleteData: SetCompleteDataTy
    userPermissions: UserPermissions

}

type InputTableLeftColumnLogicProps = InputTableLeftColumnLogicParentProps & InputTableLeftColumnLogicRequiredProps

const useInputTableLeftColumnLogic = ({ setCompleteData, updateDataURL, tabs, userPermissions, tab }: InputTableLeftColumnLogicProps) => {
    const tabsFiltered = useMemo(() => filterTabsByPermissions(tabs, userPermissions), [tabs, userPermissions])
    const { active, ComponentFromTab, setActive } = useTabObjectLogic(tabsFiltered, tab)
    const [openModal, setOpenModal] = useState<ModalOpenedTy>(null)
    const handleChange: InputTableLeftColumnChange = useCallback(async (id, field, value) => {
        setCompleteData((old) => {
            if (!old) {
                return null
            }
            old.header[field] = value
            return { ...old }
        })
        await twinFetchPostText(updateDataURL, { id, [field]: value })
    }, [updateDataURL, setCompleteData])

    const changeTab = useCallback((tabId: string) => {
        setActive(tabId)
        setOpenModal(null)
    }, [setActive, setOpenModal])

    return { handleChange, setOpenModal, openModal, active, tabsFiltered, ComponentFromTab, changeTab }
}

export type InputTableLeftColumnCompleteRequiredProps = InputTableLeftColumnRequiredProps & InputTableLeftColumnLogicRequiredProps
export default InputTableLeftColumn